import g from '#core/global';
import load from '#core/load';


const nav_link_$ = '[data-section-link]';
const inspector_toggle_$ = '[data-inspector-toggle]';
const tooltip_$ = '[data-inspector-tooltip]';
const slot_$ = '[data-slot-name]';
const slot_link_$ = '.demo--typography__slot-link';

const active_class = 'is-active';
const visible_class = 'is-visible';
const inspector_active_class = 'demo--typography--inspector-active';

let $page;
let $tooltip;
let inspector_mode = false;
let has_demo = false;


const module = {
	/**
	 * Init module
	 */
	init() {
		if (load.ran('typography-demo')) return false;

		load.content(() => {
			has_demo = assign_elements();
			if (!has_demo) return false;

			init_section_nav();
			init_inspector();
		});
	},
};

export default module;
module.init();


/**
 * Assign elements
 * @return {boolean}
 */
function assign_elements() {
	if (has_demo) return true;

	$page = document.querySelector('.typography-demo');
	$tooltip = document.querySelector(tooltip_$);

	return !!$page;
}


// --- Section navigation ---

/**
 * Initialize section navigation click handlers
 */
function init_section_nav() {
	document.addEventListener(g.click_e, (e) => {
		const $link = e.target.closest(nav_link_$);
		if (!$link) return;

		e.preventDefault();
		const section_id = $link.getAttribute('data-section-link');
		const $target = document.getElementById(section_id);
		if (!$target) return;

		$target.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});

	// Slot reference links — scroll to specimen
	document.addEventListener(g.click_e, (e) => {
		const $link = e.target.closest(slot_link_$);
		if (!$link) return;

		const href = $link.getAttribute('href');
		if (!href || !href.startsWith('#')) return;

		e.preventDefault();
		const $target = document.querySelector(href);
		if (!$target) return;

		$target.scrollIntoView({ behavior: 'smooth', block: 'center' });

		// Brief highlight
		$target.style.outline = '2px solid';
		$target.style.outlineOffset = '4px';
		setTimeout(() => {
			$target.style.outline = '';
			$target.style.outlineOffset = '';
		}, 1500);
	});
}


// --- Slot Inspector ---

/**
 * Initialize the slot inspector mode
 */
function init_inspector() {
	if (!$tooltip) return;

	const $toggle = document.querySelector(inspector_toggle_$);
	if (!$toggle) return;

	// Toggle inspector mode
	$toggle.addEventListener(g.click_e, (e) => {
		e.preventDefault();
		inspector_mode = !inspector_mode;
		$toggle.classList.toggle(active_class, inspector_mode);

		if ($page) {
			$page.classList.toggle(inspector_active_class, inspector_mode);
		}

		if (!inspector_mode) {
			hide_tooltip();
		}
	});

	// Hover: show tooltip
	document.addEventListener(g.mouse_over_e, (e) => {
		if (!inspector_mode) return;

		const $slot = e.target.closest(slot_$);
		if (!$slot) {
			hide_tooltip();
			return;
		}

		show_tooltip($slot, e);
	});

	// Track mouse position for tooltip
	document.addEventListener('mousemove', (e) => {
		if (!inspector_mode || !$tooltip.classList.contains(visible_class)) return;
		position_tooltip(e.clientX, e.clientY);
	});

	// Hide on mouseout
	document.addEventListener(g.mouse_out_e, (e) => {
		if (!inspector_mode) return;
		const $slot = e.target.closest(slot_$);
		if ($slot) {
			hide_tooltip();
		}
	});

	// Escape to exit inspector
	document.addEventListener(g.keydown_e, (e) => {
		if (e.key === 'Escape' && inspector_mode) {
			inspector_mode = false;
			$toggle.classList.remove(active_class);
			if ($page) {
				$page.classList.remove(inspector_active_class);
			}
			hide_tooltip();
		}
	});
}


/**
 * Show the inspector tooltip for a slot
 * @param {HTMLElement} $slot
 * @param {MouseEvent} e
 */
function show_tooltip($slot, e) {
	const name = $slot.getAttribute('data-slot-name') || '';
	const size = $slot.getAttribute('data-slot-size') || '';
	const signature = $slot.getAttribute('data-slot-signature') || '';
	const family = $slot.getAttribute('data-slot-family') || '';

	const lines = [
		`slot: ${name}`,
		`size: ${size}`,
		`signature: ${signature}`,
		`family: ${family}`,
	];

	$tooltip.innerHTML = lines
		.map((line) => `<span class="demo--typography__inspector-tooltip-line">${line}</span>`)
		.join('');

	$tooltip.classList.add(visible_class);
	position_tooltip(e.clientX, e.clientY);
}


/**
 * Hide the inspector tooltip
 */
function hide_tooltip() {
	if ($tooltip) {
		$tooltip.classList.remove(visible_class);
	}
}


/**
 * Position the tooltip near the cursor, keeping it in viewport
 * @param {number} x
 * @param {number} y
 */
function position_tooltip(x, y) {
	if (!$tooltip) return;

	const offset = 16;
	const rect = $tooltip.getBoundingClientRect();
	let left = x + offset;
	let top = y + offset;

	// Keep within viewport
	if (left + rect.width > window.innerWidth) {
		left = x - rect.width - offset;
	}
	if (top + rect.height > window.innerHeight) {
		top = y - rect.height - offset;
	}

	$tooltip.style.left = `${left}px`;
	$tooltip.style.top = `${top}px`;
}
